export default function TableBody(props) {
  return(
    <tbody>
      {props.children}
    </tbody>
  );
};
